import { OSKIconDefinition } from '../osk-icon.types';

export const oskIconCalendar: OSKIconDefinition = {
  name: 'calendar',
  content: '<rect width="18" height="18" x="3" y="4" rx="2" /><path d="M16 2v4M8 2v4M3 10h18" />'
};
